/** Тексты пространства «inventory». Ключи именуются по смыслу, а не по месту. */
export const inventory = {
  error: {
    load: 'Не получилось загрузить склад',
  },

  /* Заголовки «заявок нет» и «архив пуст» общие — они в common.empty. */
  empty: {
    published: {
      title: 'Склад пуст',
      text: 'Сюда складывают всё, что персонаж носит с собой или держит в комнате: каждый предмет проходит проверку модератора.',
    },
    requests: {
      text: 'Здесь висят отправленные предметы, пока их не рассмотрели, и те, что завернули.',
    },
    archived: {
      text: 'Сюда попадают предметы, которые убрали со склада.',
    },
  },

  search: {
    placeholder: 'Название предмета',
  },

  action: {
    submit: 'Отправить на проверку',
  },

  /* Врезка над формой: объясняет, что будет с правкой. */
  note: {
    create:
      'Предмет сразу уйдёт на проверку. В карточке персонажа он появится, когда модератор согласится.',
    rejected: 'Заявку завернули — в форме её текст. Поправьте и отправьте заново.',
    unpublished: 'Предмет ещё не публиковался — правка остаётся в той же заявке.',
    published: 'Правка не трогает то, что уже в карточке: она уедет отдельной версией на проверку.',
  },

  toast: {
    created: 'Предмет ушёл на проверку',
    archived: 'Предмет убран в архив',
  },

  card: {
    /** Винительный падеж: «Отправить предмет в архив?». */
    subject: 'предмет',
    archived: 'Вернуть из архива пока нельзя — попросите квест-мастера.',
  },

  form: {
    section: {
      about: 'Что это',
    },
    title: {
      placeholder: 'Что это за предмет',
    },
    image: {
      label: 'Изображение предмета',
      button: 'Предмет',
      hint: 'Необязательно. Уедет на проверку вместе с предметом.',
    },
    blocker: 'Без названия предмет не сохранить — остальное можно оставить пустым.',
  },

  tag: {
    filter: 'Метка',
    placeholder: 'Название метки',
    add: {
      label: 'Добавить метку',
      text: '+ метка',
    },
  },
} as const;
